import { ActionType } from './ActionType'

export default function getActionTypeText(actionType : ActionType) {
  // console.log({ActionType}, actionType)
  // console.log(`ActionType.Lobby[actionType]`, ActionType.Lobby[actionType])
  // console.log(`ActionType.Map[actionType]`, ActionType.Map[actionType])
  // console.log(`ActionType.Game[actionType]`, ActionType.Game[actionType])
  return ActionType.Lobby[actionType] || ActionType.Map[actionType] || ActionType.Game[actionType]
}